module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xmly-nav-right navbar"
  }, [_c('ul', {
    staticClass: "nav-right"
  }, [_c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": ("" + _vm.PROTOCOL + _vm.AVATAR_LINK + _vm.uid + "/")
    }
  }, [_c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": _vm.avatar,
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tit elli"
  }, [_vm._v(_vm._s(_vm.name))])])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": ("" + _vm.PROTOCOL + _vm.HOST + "/doc/help/download"),
      "target": "_blank",
      "download": "城市合伙人系统使用手册.pdf"
    }
  }, [_c('img', {
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACPElEQVRYR8WX7VEVQRBF741AjUCJAIlAjUCJQI1AMxAywAjECMQI1AiECMQIlAjaOtQMtT5mp2e2iqKr3g/evu050337A+uezfd8vjYDRMSJpJflAqe2j7dcZhNAOfzdzoHHto9mIbYC/JX0QNJBOfCnpEvbe3cOEBEPJf1ZOeiF7e8zENMRiIjnkr51DgHg0DZRSm0aAI8FgpBflr+fSHolCQ2QmnNJRCOFGAKICBzv2z7sXamkhwjsS/po+30WghQgIrjdLxzZnvq9pL0apTWQEYfUOyX32fab7EYlJaeSXo9EYQSAkD4rwjobBEAPXyT9sI1oV20EIMrbj0ZEVSJwU6pZ2oYBMke7V4yIa/DsvS7Asulkju4KoDadNJcNgKqdbnfMIoDqP0n6ahthDVtEIFim5VvbVEXTMoAhJy3PETEEvwqwbECShiugwoy+3wOg/X6YaUANHdQIru4KTYCiftov9Tw9YhdRqCJmKNGWbw2nNYDaSqfV36mG5nC6BbAz79NhkpXFjhYObDOqb6wFwA8Yp2fZ+M0OX6Si9oRz23WNu37cA+A5OSMdTML/yLPDI+JpmYiUI1rCLmzz/XoEeFJqmGWCSFRj++EmgPC5qlAlzI8l4ZwP4mOPqHYh6aTVkLJGhDNuQBfkgBn7TRqJYC966TRc5BEYQOgNPeMfFPQzlLJhgJagWFLK9ywfAE6X7RYAcsvt2H6XdkXeR5eW+uI0QBEpELTqOiHJ9VG2gLbytglgRonZb/8BTHX7IaSG5rQAAAAASUVORK5CYII="
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit elli"
  }, [_vm._v("帮助")])])]), _vm._v(" "), _c('li', {
    staticClass: "item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('img', {
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABQklEQVRYR+WX/VECMRDF36tAqESpAOjEDrQDsQPtwE6ECsBOoILnPCbOHNxX7pLMoe5fmblL9pe3m82GmNg4sX/cHoCkGYAXAI8APE61I4APAK8kPb6wmgKS3gA8pXptmP9O8jkGwJR3ABYkD6kgkh4A7AEcSc5jAOSfSGbLD0mtazaF4E8CnENJ0uHoTcLsCnTlUbEQSNqGZF43Hb8fqNIASwCWvxWiJICLmFW474IoBmCJQ1XthCgKEAORBCDJ8bXEQ2xLcp0lCUcC7EiusgDEbDvkwScAF6EvAKvqsUwKQR9An/NzdbxepOvi6HNY/R7jvDSAj58LUU32KmhJBQzgYnQR8/9zGV3lg+uFSC4mUeDXdUSlmtITyVqbf5NtuSk34WHi9jzVTuFhsol6mKR6Gzo/W+8/1HHrbTh2obHzvgGJ3dkh/zGD/AAAAABJRU5ErkJggg=="
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit elli"
  }, [_vm._v("退出")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b46fa05","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Navbar.vue
// module id = 927
// module chunks = 1